import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, " aaaaaaaa ", -1)
const _hoisted_2 = { class: "mt-20 flex flex-col gap-4 items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold" }, "Não encontrado", -1)
const _hoisted_4 = { class: "font-semibold text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        _createTextVNode("Não foi possível encontrar a pagina. "),
        _createVNode(_component_RouterLink, {
          to: "/",
          class: "text-verde-escuro"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Volte para a página principal. ")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}